import { createFileRoute } from "@tanstack/react-router";
import Learn from "@/pages/Learn";
import { publishedArticlesQuery } from "@/lib/publishedArticlesQuery";
import { pageHead, unavailableHead } from "@/lib/seoPolicy";
import NotFound from "@/pages/NotFound";

export const Route = createFileRoute("/_public/learn/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(publishedArticlesQuery),
  head: ({ loaderData }) => loaderData ? pageHead("Fence Buying Guides & Cost Breakdowns | Modern Fence Install", "Honest, no-marketing guides on dog fences, deer fences, garden protection, fence cost, and the install process. From the team that builds them.", "/learn") : unavailableHead(),
  errorComponent: () => <section role="alert" className="container py-20"><h1 className="text-2xl font-bold">Articles are temporarily unavailable</h1><p>Please try again shortly.</p></section>,
  notFoundComponent: NotFound,
  component: Learn,
});
